import {validateSimBySimCardCall, validateDeviceCall, rentProduct, getProductsByType, addActiveSimRequestCall, addActiveDeviceRequestCall, validateActiveSimCall, getSimDetailsCall, validateDeviceIMEICall} from "../services/mightyWifiApi";
import { SET_PRODUCT,SET_PRODUCTS } from "./types";
export function setProduct(product) {
  return {
    type: SET_PRODUCT,
    product
  };
}

export function setProducts(products) {
  return {
    type: SET_PRODUCTS,
    products
  };
}

export function getRentProduct() {
  return dispatch => {
    return rentProduct().then(res => {
      if (res.status) {
        dispatch(setProduct(res.product));
      }
    });
  };
}

export function getRechargeSimProducts() {
  return dispatch => {
    return getProductsByType("recharge").then(res => {
      if (res.status) {
        dispatch(setProducts(res.products));
      }
    });
  };
}

export function validateActiveSim(payload) {
  return dispatch => {
    return validateActiveSimCall(payload)
  }
}

export function validateSimBySimCard(payload) {
  return dispatch => {
    return validateSimBySimCardCall(payload)
  }
}

export function validateDevice(payload) {
  return dispatch => {
    return validateDeviceCall(payload)
  }
}

export function validateDeviceIMEI(imei) {
  return dispatch => {
    return validateDeviceIMEICall(imei)
  }
}

export function getSimDetails(number) {
  return dispatch => {
    return getSimDetailsCall(number)
  }
}

export function addActiveSimRequest(payload) {
  return dispatch => {
    return addActiveSimRequestCall(payload)
  }
}

export function addActiveDeviceRequest(payload) {
  return dispatch => {
    return addActiveDeviceRequestCall(payload)
  }
}

export const getDeviceProduct = (version) => {
  return dispatch => {
    return getProductsByType('device', version).then(res => {
      if (res.status) {
        dispatch(setProducts(res.products));
      }
    });
  };
};

export const getRechargeDeviceProduct = () => {
  return dispatch => {
    return getProductsByType('recharge_device').then(res => {
      if (res.status) {
        dispatch(setProducts(res.products));
      }
    });
  };
};

export const getSimProducts = () => {
  return dispatch => {
    return getProductsByType('sim').then(res => {
      if (res.status) {
        dispatch(setProducts(res.products));
      }
    });
  };
};

export const getESimProducts = () => {
  return dispatch => {
    return getProductsByType('esim').then(res => {
      if (res.status) {
        dispatch(setProducts(res.products));
      }
    });
  };
};

export const getLycaSimProducts = () => {
  return dispatch => {
    return getProductsByType('lyca_sim').then(res => {
      if (res.status) {
        dispatch(setProducts(res.products));
      }
    });
  };
};


// WEBPACK FOOTER //
// ./src/modules/actions/productActions.js